"use client";

import { useAppSelector } from "lib/redux/hooks";
import {
  changeDocumentSize,
  changeFontFamily,
  changeFontSize,
  changeFormsOrder,
  changeFormToHeading,
  changeFormToShow,
  changeLeftRightFormOrder,
  changePublishedStatus,
  changeThemeColor,
  selectEducations,
  selectResume,
} from "lib/redux/resumeSlice";
// import { Resume } from "lib/redux/types";
import { Suspense, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setResume } from "lib/redux/resumeSlice";
import { SaveResumePopup } from "components/SaveResumePopup";
import { toast, ToastContainer } from "react-toastify";
import { ResumePublishOptions } from "components/ResumePublishOptions";
import { changeResumeVisibility } from "api/resumeApi";
import { ScoreNavbar } from "./components/ScoreNavbar";
import {
  selectIsExplorePlansOverlayOpen,
  selectUiSettings,
  setIsExplorePlansOverlayOpen,
  setIsPremiumUser,
  setSubscriptionCreditCount,
  setIsAuthenticationOpen,
  selectIsAuthenticationOpen,
  setOpenMobileResumeOverlay,
  selectOpenMobileResumeOverlay,
  selectIsPremiumUser,
} from "lib/redux/uiSlice";
import { ExplorePlansOverlay } from "components/OverlaysAndPopups/ExplorePlansOverlay";
import { fetchCountryCode } from "lib/utils/getCountryCode";
import { getSubscriptionInfo } from "api/subscription/subscriptionInfo";
import {
  selectScale,
  selectSettings,
  setScale,
  setTemplate,
  setTemplateWithDefaults,
  setLeftRightFormOrder,
  type ShowForm,
} from "lib/redux/settingsSlice";
import { AuthenticationOptions } from "components/AuthenticationOptions";
import { createResumeScoringRequestBody } from "lib/resume-scoring/request-body/request-body";
import { analyseResume } from "api/resume-scoring/analyse-resume";
import { analyseResumeForScoring } from "lib/resume-scoring/resume-analysis";
import { scoreResume } from "lib/resume-scoring";
import { ResumeAnalysis } from "lib/resume-scoring/resume-analysis/resume-analyse-types";
import { removeExtraWeakVerbs } from "./utils/removeExtraWeakVerb";
import {
  getExperienceCache,
  getResumeAnalysisCache,
  getResumeCache,
  getResumeScoreCache,
  setExperienceCache,
  setResumeAnalysisCache,
  setResumeCache,
  setResumeScoreCache,
} from "./utils/localStorageHelper";
import { redirect, useRouter, useSearchParams } from "next/navigation";
import { Navbar } from "home/Navbar";
import { cx } from "lib/cx";
import { ResumeIframeCSR } from "components/Resume/ResumeIFrame";
import { DEBUG_RESUME_PDF_FLAG } from "lib/constants";
import { useTemplateComponents } from "components/Resume/templateUtils";
import { TotalScoreBar } from "./components/TotalScoreBar";
import { FeedbackButton } from "./components/FeebackButton";
import ScoringLoadingModal from "components/ResumeScore/loading/ScoringLoadingModal";
import MobileTotalScore from "./components/MobileTotalScore";
import { MobileResumeOverlay } from "components/MobileResumeOverlay";
import {
  setAnalysis as setGlobalAnalysis,
  setScoreAnalysis as setGlobalScoreAnalysis,
  setScore as setGlobalScore,
  setExperienceLevel as setGlobalExperienceLevel,
  selectAnalysis,
  selectScoreAnalysis,
  selectScore,
  selectExperienceLevel,
  selectIsAnalysisLoading,
  setIsAnalysisLoading,
} from "../lib/redux/scoreAnalysisSlice";
import { ExplorePlans } from "./components/ExplorePlans";
import { removeVoidGrammarMistakes } from "./utils/removeVoidGrammerMistakes";
// import NavbarSuspense from "components/NavbarSuspense";
import { useRegisterReactPDFFont } from "components/fonts/hooks";
import { removeFakeSpellingMistakes } from "./utils/removeFakeSpellingMistakes";
import { enableHighlight, disableHighlight } from "lib/redux/highlightSlice";
import { ResumeIframeProviders } from "components/Resume/ResumeIframeProviders";
// import { ResumePDF } from "components/Resume/ResumePDF";
import { ScoreCheckProvider } from "./ScoreCheckContext";
import { ResumeControlBarCSR } from "components/Resume/ResumeControlBar";
// import { type MistakeAnalysisData } from "components/Resume/MistakeAnalysisContext";
import { useMemo } from "react";
import { transformAnalysisToMistakeData } from "./utils/analysisDatatoMistakeData";


export default function ScoreCheckLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  // Keep all the state and logic from the original component
  const router = useRouter();
  const searchParams = useSearchParams();
  const [hasAddedNewResume, setHasAddedNewResume] = useState(false);
  const [isLocalLoading, setIsLocalLoading] = useState(true);
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [isServerError, setIsServerError] = useState(false);
  const [openShareResumeModal, setOpenShareResumeModal] = useState(false);
  const isExplorePlansOverlayOpen = useAppSelector(
    selectIsExplorePlansOverlayOpen
  );
  const settings = useAppSelector(selectSettings);
  const ui = useAppSelector(selectUiSettings);
  const [openSaveResumePopup, setOpenSaveResumePopup] = useState(false);
  const [countryCode, setCountryCode] = useState("IN");
  const resume = useAppSelector(selectResume);
  const isAuthenticationOpen = useAppSelector(selectIsAuthenticationOpen);
  const educations = useAppSelector(selectEducations);
  const dispatch = useDispatch();
  const openMobileResumeOverlay = useAppSelector(selectOpenMobileResumeOverlay);
  const [is403, setIs403] = useState(false);
  const isPremiumUser = useAppSelector(selectIsPremiumUser);
  const [openTemplatesPreview, setOpenTemplatesPreview] = useState(false);
  const [openMobileThemeForm, setOpenMobileThemeForm] = useState(false);
  const Barscale = useAppSelector(selectScale);
  const setScaleValue = (value: number) => dispatch(setScale(value));

  useRegisterReactPDFFont();

  // Use Redux state instead of local state
  const isLoading = useAppSelector(selectIsAnalysisLoading);
  const analysis = useAppSelector(selectAnalysis);
  const scoreAnalysis = useAppSelector(selectScoreAnalysis);
  const score = useAppSelector(selectScore);
  const experienceLevel = useAppSelector(selectExperienceLevel);

  // Transform analysis data for persistent mistake highlighting
  const mistakeData = useMemo(() => {
    return transformAnalysisToMistakeData(analysis);
  }, [analysis]);
  // console.log("Mistake Data in Layout:", mistakeData);

  const resumeI = useAppSelector(selectResume);
  const { TemplateNameToHighlightResume, templateNameToDocument, template } =
    useTemplateComponents(resume, settings);

  useEffect(() => {
    const accessToken = localStorage.getItem("access-token");
    setAccessToken(accessToken);
    dispatch(setIsExplorePlansOverlayOpen(false));
    try {
      const subscriptionInfo = async () => {
        const tokenCount = await getSubscriptionInfo();
        dispatch(setSubscriptionCreditCount(tokenCount.credits));
        dispatch(setIsPremiumUser(tokenCount.premium));
      };
      if (accessToken) {
        subscriptionInfo();
      }
    } catch (error) {}
  }, []);

  // Enable highlighting feature on score-check page mount
  // Disable on unmount to ensure it's only active on this page
  useEffect(() => {
    dispatch(enableHighlight());
    return () => {
      dispatch(disableHighlight());
    };
  }, [dispatch]);

  useEffect(() => {
    const localAccessToken = localStorage.getItem("access-token");
    if (!localAccessToken) {
      dispatch(setIsAuthenticationOpen(true));
      redirect("/");
    }
    // Get cached data
    const cachedAnalysis = getResumeAnalysisCache();
    const cachedScore = getResumeScoreCache();
    const cachedResume = getResumeCache();
    const cachedExperience = getExperienceCache();

    // Determine the source of navigation
    const isFromExperiencePage = searchParams.get("source") === "experience";
    const isFromDashboard =
      searchParams.get("source") === "dashboard" ||
      searchParams.get("source") === "builder";

    // Get experience level from URL if available
    const levelFromUrl = searchParams.get("level");
    const hasExperienceInUrl =
      levelFromUrl &&
      (levelFromUrl === "FRESHER" || levelFromUrl === "EXPERIENCED");

    // Clean URL parameters after reading them
    if (typeof window !== "undefined") {
      try {
        if (window.location.href.includes("?")) {
          const url = new URL(window.location.href);
          url.searchParams.delete("source");
          url.searchParams.delete("level");
          const cleanUrl =
            url.searchParams.toString() === ""
              ? window.location.href.split("?")[0]
              : url.toString();
          window.history.replaceState({}, "", cleanUrl);
        }
      } catch (e) {}
    }

    // FLOW 1: User coming from experience selector
    if (isFromExperiencePage) {
      // Save the experience level from URL to localStorage
      if (hasExperienceInUrl) {
        dispatch(
          setGlobalExperienceLevel(levelFromUrl as "FRESHER" | "EXPERIENCED")
        );
        setExperienceCache({ experience: levelFromUrl });
      }

      // Check if we have resume in Redux (set during experience selection)
      if (!resume || !resume.profile) {
        // No resume in Redux, check if we have cached resume
        if (!cachedResume) {
          // No resume available, redirect to upload
          router.push("/upload-resume");
          return;
        }
        // Use cached resume if available
        dispatch(setResume(cachedResume));
        // Sync template from resume to settings with defaults
        if (cachedResume.templateId) {
          dispatch(setTemplateWithDefaults(cachedResume.templateId));
          // Apply leftRightFormOrder from saved resume (critical for 2-column templates)
          if (cachedResume.leftRightFormOrder) {
            dispatch(setLeftRightFormOrder({
              left: cachedResume.leftRightFormOrder.left as ShowForm[],
              right: cachedResume.leftRightFormOrder.right as ShowForm[]
            }));
          }
        }
      }

      // Run analysis with the provided experience level
      setIsLocalLoading(false);
      handleAnalyseResume();
      return;
    }

    // FLOW 2: User coming from dashboard/builder
    else if (isFromDashboard) {
      // Check if we have resume in Redux state
      if (!resume || !resume.profile) {
        if (!cachedResume) {
          // No resume available, redirect to upload
          router.push("/upload-resume");
          return;
        }
        dispatch(setResume(cachedResume));
        // Sync template from resume to settings with defaults
        if (cachedResume.templateId) {
          dispatch(setTemplateWithDefaults(cachedResume.templateId));
          // Apply leftRightFormOrder from saved resume (critical for 2-column templates)
          if (cachedResume.leftRightFormOrder) {
            dispatch(setLeftRightFormOrder({
              left: cachedResume.leftRightFormOrder.left as ShowForm[],
              right: cachedResume.leftRightFormOrder.right as ShowForm[]
            }));
          }
        }
      }

      // Check if we have experience level in localStorage
      if (!cachedExperience) {
        // No experience level, redirect to experience selector
        router.push("/select-experience");
        return;
      }

      // Set the experience level from localStorage
      dispatch(setGlobalExperienceLevel(cachedExperience));

      // Run analysis with the stored experience level
      setIsLocalLoading(false);
      handleAnalyseResume();
      return;
    }

    // FLOW 3: User coming directly to score-check
    else {
      // Check if all required data exists in localStorage
      if (
        !cachedResume ||
        !cachedExperience ||
        !cachedScore ||
        !cachedAnalysis
      ) {
        // Missing required data, redirect to upload
        router.push("/upload-resume");
        return;
      }

      // We have all required data, set up the page using cached data
      dispatch(setResume(cachedResume));
      // Sync template from resume to settings with defaults
      if (cachedResume.templateId) {
        dispatch(setTemplateWithDefaults(cachedResume.templateId));
        // Apply leftRightFormOrder from saved resume (critical for 2-column templates)
        if (cachedResume.leftRightFormOrder) {
          dispatch(setLeftRightFormOrder({
            left: cachedResume.leftRightFormOrder.left as ShowForm[],
            right: cachedResume.leftRightFormOrder.right as ShowForm[]
          }));
        }
      }
      

      // Dispatch to Redux store directly
      dispatch(setGlobalAnalysis(cachedAnalysis));
      dispatch(setGlobalScoreAnalysis(cachedScore));
      dispatch(setGlobalScore(Math.ceil(cachedScore.totalScore)));
      dispatch(setGlobalExperienceLevel(cachedExperience));

      setIsLocalLoading(false);
      return;
    }
  }, [dispatch, router, resume?.id]);

  /**
   * Calculate resume score based on analysis and experience level
   * This function can be called directly without API when changing experience level
   */
  const calculateAndUpdateScore = (
    analysisData: ResumeAnalysis,
    expLevel: "FRESHER" | "EXPERIENCED",
    // currentResume: Resume
  ) => {
    if (!analysisData || !expLevel) {
      return;
    }

    // Calculate scores based on the analysis and experience level
    const resumeScores = scoreResume(analysisData, expLevel);

    // Save to localStorage for future visits - use the resume that was actually analyzed
    setResumeAnalysisCache({ resumeAnalysis: analysisData });
    setResumeCache({ resume });
    setExperienceCache({ experience: expLevel });
    setResumeScoreCache({ score: resumeScores });

    // Update Redux store directly - no need for setTimeout now that we're fully on Redux
    dispatch(setGlobalAnalysis(analysisData));
    dispatch(setGlobalScoreAnalysis(resumeScores));
    dispatch(setGlobalScore(Math.ceil(resumeScores.totalScore)));
    dispatch(setGlobalExperienceLevel(expLevel));

    return resumeScores;
  };

  /**
   * Handle the analysis of the resume, including API call and score calculation
   */
  const handleAnalyseResume = async () => {
    if (!resume) {
      setIsServerError(true);
      return;
    }
    const currentExperience = experienceLevel || getExperienceCache();
    if (!currentExperience) {
      toast.error("Experience level is required for scoring");
      setIsServerError(true);
      return;
    }

    if (!experienceLevel && currentExperience) {
      dispatch(setGlobalExperienceLevel(currentExperience));
    }

    setIsServerError(false);
    dispatch(setIsAnalysisLoading(true));
    try {
      // Make the API call to analyze the resume
      const requestBody = createResumeScoringRequestBody(resume);
      const res = await analyseResume(requestBody);

      if (res) {
        // Add GPA information to the analysis
        const resWithGpa = { ...res.data };
        // Check if educations exists in the response
        if (
          resWithGpa.educations &&
          resWithGpa.educations.individualEducationsAnalysis
        ) {
          resWithGpa.educations.individualEducationsAnalysis =
            resWithGpa.educations.individualEducationsAnalysis.map(
              (edu: any, index: number) => ({
                ...edu,
                gpa:
                  educations && educations[index] && educations[index].gpa
                    ? educations[index].gpa
                    : null,
              })
            );
        }

        // Process the analysis data
        const analysedResume = await analyseResumeForScoring(resWithGpa);
        const analysisAfterRemovingExtraWeakVerbs =
          removeExtraWeakVerbs(analysedResume);
        const analysisAfterRemovingVoidGrammarMistakes =
          removeVoidGrammarMistakes(analysisAfterRemovingExtraWeakVerbs);
        const analysisAfterRemovingFakeSpellingMistakes =
          removeFakeSpellingMistakes(analysisAfterRemovingVoidGrammarMistakes);

        // Use the separated function to calculate and update scores
        const experienceLevelForScoring = experienceLevel || currentExperience;
        calculateAndUpdateScore(
          analysisAfterRemovingFakeSpellingMistakes,
          experienceLevelForScoring,
          // resume // Pass the current resume that was analyzed
        );
      } else {
        setIsServerError(true);
      }
    } catch (error) {
      console.log("Error during resume analysis:", error);
      const cachedResume = getResumeCache();
      if (cachedResume) {
        dispatch(setResume(cachedResume));
      }
      setIs403(true);
      setIsServerError(true);
    } finally {
      dispatch(setIsAnalysisLoading(false));

      if (typeof window !== "undefined" && window.location.href.includes("?")) {
        try {
          const cleanUrl = window.location.href.split("?")[0];
          window.history.replaceState({}, "", cleanUrl);
        } catch (e) {
          // Silent catch
        }
      }
    }
  };

  useEffect(() => {
    dispatch(changeThemeColor(settings.themeColor));
    dispatch(changeFontFamily(settings.fontFamily));
    dispatch(changeFontSize(settings.fontSize));
    dispatch(changeDocumentSize(settings.documentSize));
    dispatch(changeFormToShow(settings.formToShow));
    dispatch(changeFormToHeading(settings.formToHeading));
    dispatch(changeFormsOrder(settings.formsOrder));
    dispatch(changeLeftRightFormOrder(settings?.leftRightFormOrder!));
  }, [dispatch, settings, ui.userProfilePhoto]);

  useEffect(() => {
    fetchCountryCode(setCountryCode);
  }, []);

  const handleChangeResumeVisibility = async (
    resumeId: number,
    visibility: boolean
  ) => {
    try {
      await changeResumeVisibility(resumeId, {
        published: visibility,
      });
      dispatch(changePublishedStatus(visibility));
    } catch (error) {
      toast.error("Error updating resume visibility");
    }
  };

  if (isLoading) {
    return <ScoringLoadingModal isLoadingComplete={!isLoading} />;
  }

  if (isLocalLoading) {
    return <ScoringLoadingModal isLoadingComplete={!isLocalLoading} />;
  }

  if (is403) {
    return <ExplorePlans countryCode={countryCode} />;
  }
  // console.log(is403)
  // console.log(analysis?.projects)

  // New layout that splits the screen into 2/3 for content and 1/3 for resume preview
  return (
    <main className="relative h-screen w-full overflow-hidden bg-[#F1F1F1]">
      <ScoreNavbar
        setOpenSaveResumePopup={setOpenSaveResumePopup}
        setOpenShareResumeModal={setOpenShareResumeModal}
        setHasAddedNewResume={setHasAddedNewResume}
        handleAnalyseResume={handleAnalyseResume}
        calculateAndUpdateScore={calculateAndUpdateScore}
      />

      {/* Two column layout */}
      <div className="no-scrollbar flex max-h-[calc(100vh-80px)] gap-3 px-2 pt-2 sm:px-6 md:px-8 lg:max-h-[calc(100vh-75px)] xl:max-h-[calc(100vh-75px)] xl:pt-3">
        {/* Left side (2/3): Section content */}
        <div className="no-scrollbar flex max-h-full w-full flex-col gap-2 overflow-y-auto lg:w-2/3">
          <Suspense
            fallback={
              <main className="relative h-screen w-full overflow-hidden bg-[#F1F1F1]">
                <div className="flex h-screen w-full items-center justify-center">
                  <div role="status">
                    <svg
                      aria-hidden="true"
                      className="h-40 w-40 animate-spin fill-blue-600 text-gray-200"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="#2563eb"
                      />
                    </svg>
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </main>
            }
          >
            <ScoreCheckProvider
              handleAnalyseResume={handleAnalyseResume}
              calculateAndUpdateScore={calculateAndUpdateScore}
            >
              {children}
            </ScoreCheckProvider>
          </Suspense>
        </div>

        {/* Right side (1/3): Resume Preview */}
        <div className="hidden flex-1 items-center justify-center gap-4 lg:flex lg:w-1/3 lg:flex-1 lg:flex-col">
          <TotalScoreBar totalScore={score!} maxTotalScore={100} />

          <section
            className={cx(
              "flex w-full items-center justify-center px-2 sm:px-4 md:px-5",
              "h-[60vh] sm:h-[70vh] lg:h-[calc(100vh-80px)]",
              "overflow-y-scroll scrollbar",
              "hidden lg:block",
              "flex-1"
            )}
          >
            <Suspense
              fallback={
                <main className="relative h-screen w-full overflow-hidden bg-[#F1F1F1]">
                  <div className="flex h-screen w-full items-center justify-center">
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        className="h-40 w-40 animate-spin fill-blue-600 text-gray-200"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="#2563eb"
                        />
                      </svg>
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </main>
              }
            >
              <ResumeIframeCSR
                documentSize="A4"
                scale={Barscale}
                enablePDFViewer={DEBUG_RESUME_PDF_FLAG}
              >
                <ResumeIframeProviders mistakeData={mistakeData}>
                  {resumeI && TemplateNameToHighlightResume[template]}
                </ResumeIframeProviders>
              </ResumeIframeCSR>
            </Suspense>
          </section>
          <div className="w-11/12 flex mx-auto items-center justify-center bg-white p-1 rounded-xl">
            <ResumeControlBarCSR
              scale={Barscale}
              setScale={setScaleValue}
              documentSize={settings.documentSize}
              document={templateNameToDocument[template]}
              fileName={resume.profile.name + " - Resume"}
            />
          </div>
        </div>
      </div>

      {/* Popups and modals */}
      {openSaveResumePopup && (
        <SaveResumePopup onClose={() => setOpenSaveResumePopup(false)} />
      )}
      {openShareResumeModal && (
        <ResumePublishOptions
          onClose={() => setOpenShareResumeModal(false)}
          resumeId={resume.id!}
          handleChangeResumeVisibility={handleChangeResumeVisibility}
          published={resume.published!}
        />
      )}
      {isExplorePlansOverlayOpen && (
        <ExplorePlansOverlay countryCode={countryCode} />
      )}
      {isAuthenticationOpen && <AuthenticationOptions />}
      {openMobileResumeOverlay && (
        <MobileResumeOverlay
          setOpenShareResumeModal={setOpenShareResumeModal}
          setOpenSaveResumePopup={setOpenSaveResumePopup}
          setOpenTemplatesPreview={setOpenTemplatesPreview}
          setOpenMobileThemeForm={setOpenMobileThemeForm}
        />
      )}

      <div
        className="absolute bottom-24 right-5 z-40"
        onClick={() => dispatch(setOpenMobileResumeOverlay(true))}
      >
        <MobileTotalScore progress={score!} />
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <FeedbackButton />
    </main>
  );
}

//
// select-experience image border ig (done)
// thin line in select-experience (done)
// increase transition time for image (done)
// fresher thoda upar (done)
//
// links vertical for link missing in personal (done)
//
// show yellow when date issue
//
// date consistent ignore OTHER case (done)
//
// padding issue in header (done)
//
// description background white remove (done)
//
